import { propValueOr } from "../../helpers/common";

export const getPlayers = state => {
  const users = propValueOr(state, "gameState.game.users", []);
  return users;
};
